import * as React from 'react'
import Box from '@mui/material/Box'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import { ETimeslotType } from '@/store/apis/timeslots'
import { useTranslation } from 'react-i18next'
import { getTimeslotTypeColor } from './calendarTypes'

interface ITimeslotTypeDropDownProps {
  onChange: (values: ETimeslotType) => void
  defaultValue: ETimeslotType
}

const CellTypeDropDown: React.FC<ITimeslotTypeDropDownProps> = ({
  onChange,
  defaultValue,
}) => {
  const { t } = useTranslation()
  const [timeslotType, setTimeslotType] = React.useState(defaultValue)

  const handleChange = (event: SelectChangeEvent) => {
    setTimeslotType(event.target.value as ETimeslotType)
    onChange(event.target.value as ETimeslotType)
  }

  return (
    <Box sx={{ width: '300px' }}>
      <FormControl fullWidth>
        <InputLabel sx={{ fontWeight: 'bold' }}>
          {t('cellType.type')}
        </InputLabel>
        <Select
          value={timeslotType}
          label={t('slotType')}
          onChange={handleChange}
          sx={{
            backgroundColor: getTimeslotTypeColor(timeslotType),
            color: '#FFFFFF',
            fontWeight: 'bold',
          }}
        >
          <MenuItem value={ETimeslotType.Disabled}>
            {t('cellType.disabled')}
          </MenuItem>
          <MenuItem value={ETimeslotType.Important}>
            {t('cellType.important')}
          </MenuItem>
          <MenuItem value={ETimeslotType.Required}>
            {t('cellType.required')}
          </MenuItem>
        </Select>
      </FormControl>
    </Box>
  )
}

export default CellTypeDropDown
